/* HexGuard Lösungsfinder (2026-10-09; dedicated page since revision d)
   Steps: problem → location (only where curated location rules exist) → method (only if >1) → results.
   Results: up to 3 real products per category via the Section Rendering API (sections/hg-finder-results).
   No add-to-cart here: every result leads to the product page (variants, warnings, documents). */
(function () {
  'use strict';
  var root = document.querySelector('[data-hg-lf]');
  var dataEl = document.querySelector('[data-hg-lf-data]');
  var startBtn = document.querySelector('[data-hg-lf-start]');
  // standalone = the dedicated finder page: first question on load, no launcher, no close
  var standalone = !!root && root.hasAttribute('data-hg-lf-standalone');
  if (!root || !dataEl || (!startBtn && !standalone)) return;
  var HL = root.getAttribute('data-hg-lf-hlevel') || 'h4';

  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  // Liquid's t filter HTML-escapes ("&amp;"); decode once because labels are inserted as text, never as HTML
  function decode(v) {
    if (typeof v === 'string') { var t = document.createElement('textarea'); t.innerHTML = v; return t.value; }
    if (v && typeof v === 'object') { Object.keys(v).forEach(function (k) { v[k] = decode(v[k]); }); }
    return v;
  }
  var T = decode(D.i18n);
  var PROBLEMS = D.problems || [];
  var stage = root.querySelector('[data-hg-lf-stage]');
  var progressEl = root.querySelector('[data-hg-lf-progress]');
  var summaryEl = root.querySelector('[data-hg-lf-summary]');
  var statusEl = root.querySelector('[data-hg-lf-status]');
  var launch = document.querySelector('[data-hg-lf-launch]');
  var cache = {};
  var state = { problem: null, location: null, method: null, b2b: false, step: 'problem' };
  var requestId = 0;

  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'text') n.textContent = attrs[k];
      else if (k === 'html') n.innerHTML = attrs[k]; // only used for trusted, server-rendered SVG icons
      else if (k.indexOf('on') === 0) n.addEventListener(k.slice(2), attrs[k]);
      else if (attrs[k] !== null && attrs[k] !== undefined) n.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return n;
  }
  function fmt(s, map) { Object.keys(map).forEach(function (k) { s = s.split(k).join(map[k]); }); return s; }
  function announce(msg) { statusEl.textContent = ''; setTimeout(function () { statusEl.textContent = msg; }, 50); }
  function problemById(id) { return PROBLEMS.filter(function (p) { return p.id === id; })[0] || null; }

  /* ---------- rule helpers ---------- */
  /* Locations are only asked where curated rules name one (e.g. "auto" = the store's "…fürs Auto" categories).
     "other" = the general categories of that pest; results then make no location claim. */
  function explicitLocs(p) {
    var seen = [];
    (p.rules || []).forEach(function (r) { if (r.loc !== 'any' && seen.indexOf(r.loc) < 0) seen.push(r.loc); });
    return seen;
  }
  function locations(p) {
    var locs = explicitLocs(p);
    if (locs.length && (p.rules || []).some(function (r) { return r.loc === 'any'; })) locs.push('other');
    return locs;
  }
  function rulesFor(p, loc) {
    var rules = p.rules || [];
    if (!loc || loc === 'unsure') return rules;
    if (loc === 'other') return rules.filter(function (r) { return r.loc === 'any'; });
    return rules.filter(function (r) { return r.loc === loc; });
  }
  function explicitLoc() { return state.location && state.location !== 'unsure' && state.location !== 'other'; }
  function methodsFor(p, loc) {
    var seen = [];
    rulesFor(p, loc).forEach(function (r) { if (seen.indexOf(r.method) < 0) seen.push(r.method); });
    return seen;
  }
  function steps() {
    var s = ['problem'];
    var p = problemById(state.problem);
    if (p && state.problem !== 'unsure') {
      if (locations(p).length > 1) s.push('location');
      if (methodsFor(p, state.location).length > 1) s.push('method');
    }
    s.push('results');
    return s;
  }

  /* ---------- chrome: progress + summary ---------- */
  function renderProgress() {
    var s = steps();
    progressEl.innerHTML = '';
    s.forEach(function (name, i) {
      var cur = name === state.step;
      var done = s.indexOf(state.step) > i;
      progressEl.appendChild(el('li', { class: 'hg-lf__dot' + (cur ? ' is-current' : '') + (done ? ' is-done' : ''), 'aria-current': cur ? 'step' : null }, [
        el('span', { class: 'hg-lf__dot-n', text: String(i + 1) }),
        el('span', { class: 'hg-lf__dot-l', text: T['step_' + name] || name })
      ]));
    });
  }
  function chip(label, step) {
    return el('button', { type: 'button', class: 'hg-lf__chip', onclick: function () { go(step); } }, [label, el('span', { class: 'hg-lf__chip-edit', text: T.change })]);
  }
  function renderSummary() {
    summaryEl.innerHTML = '';
    var p = problemById(state.problem);
    if (!p) return;
    summaryEl.appendChild(chip(p.label, 'problem'));
    if (state.location) summaryEl.appendChild(chip(state.location === 'unsure' ? T.skip : T.loc[state.location], 'location'));
    if (state.method) summaryEl.appendChild(chip(state.method === 'none' ? T.no_pref : (T.method[state.method] || state.method), 'method'));
  }

  /* ---------- navigation ---------- */
  function go(step, opts) {
    state.step = step;
    renderProgress();
    renderSummary();
    if (step === 'problem') renderProblem();
    else if (step === 'location') renderLocation();
    else if (step === 'method') renderMethod();
    else renderResults();
    if (!opts || opts.focus !== false) {
      var h = stage.querySelector('[data-hg-focus]');
      if (h) h.focus({ preventScroll: false });
    }
  }
  function next() {
    var s = steps();
    var i = s.indexOf(state.step);
    go(s[Math.min(i + 1, s.length - 1)]);
  }
  function back() {
    var s = steps();
    var i = s.indexOf(state.step);
    if (i > 0) go(s[i - 1]);
  }
  function choose(field, value) {
    state[field] = value;
    // changing an answer clears every later, possibly incompatible answer
    if (field === 'problem') { state.location = null; state.method = null; }
    if (field === 'location') { state.method = null; }
    next();
  }

  function option(label, hint, iconSvg, selected, onPick, extraClass) {
    return el('button', { type: 'button', class: 'hg-lf__opt' + (extraClass ? ' ' + extraClass : ''), 'aria-pressed': selected ? 'true' : 'false', onclick: onPick }, [
      iconSvg ? el('span', { class: 'hg-lf__opt-ico', 'aria-hidden': 'true', html: iconSvg }) : null,
      el('span', { class: 'hg-lf__opt-text' }, [el('span', { class: 'hg-lf__opt-label', text: label }), hint ? el('span', { class: 'hg-lf__opt-hint', text: hint }) : null])
    ]);
  }
  function stepShell(legend, children, withBack) {
    var fs = el('fieldset', { class: 'hg-lf__step' }, [el('legend', { class: 'hg-lf__q', tabindex: '-1', 'data-hg-focus': '', text: legend })].concat(children));
    var wrap = el('div', {}, [fs]);
    if (withBack) wrap.appendChild(el('div', { class: 'hg-lf__nav' }, [el('button', { type: 'button', class: 'hg-lf__link', onclick: back, text: '← ' + T.back })]));
    stage.innerHTML = '';
    stage.appendChild(wrap);
  }

  function renderProblem() {
    var groups = ['nager', 'tiere', 'insekten', 'garten'];
    var kids = [];
    groups.forEach(function (g) {
      var items = PROBLEMS.filter(function (p) { return p.group === g; });
      if (!items.length) return;
      kids.push(el('p', { class: 'hg-lf__group', text: T['group_' + g] }));
      kids.push(el('div', { class: 'hg-lf__opts hg-lf__opts--tiles' }, items.map(function (p) {
        return option(p.label, null, p.icon, state.problem === p.id, function () { choose('problem', p.id); }, 'hg-lf__opt--tile');
      })));
    });
    kids.push(el('div', { class: 'hg-lf__opts hg-lf__opts--secondary' }, [option(T.unsure, T.unsure_hint, null, state.problem === 'unsure', function () { choose('problem', 'unsure'); }, 'hg-lf__opt--ghost')]));
    stepShell(T.q_problem, kids, false);
  }
  function renderLocation() {
    var p = problemById(state.problem);
    var opts = locations(p).map(function (l) { return option(T.loc[l] || l, null, null, state.location === l, function () { choose('location', l); }); });
    opts.push(option(T.skip, null, null, state.location === 'unsure', function () { choose('location', 'unsure'); }, 'hg-lf__opt--ghost'));
    stepShell(T.q_location, [el('div', { class: 'hg-lf__opts' }, opts)], true);
  }
  function renderMethod() {
    var p = problemById(state.problem);
    var opts = methodsFor(p, state.location).map(function (m) { return option(T.method[m] || m, T.hint[m] || null, null, state.method === m, function () { choose('method', m); }); });
    opts.push(option(T.no_pref, T.no_pref_hint, null, state.method === 'none', function () { choose('method', 'none'); }, 'hg-lf__opt--ghost'));
    stepShell(T.q_method, [el('div', { class: 'hg-lf__opts' }, opts)], true);
  }

  /* ---------- results ---------- */
  function fetchCategory(url) {
    if (cache[url]) return Promise.resolve(cache[url]);
    var u = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=hg-finder-results&sort_by=best-selling';
    return fetch(u, { headers: { Accept: 'text/html' } }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var box = doc.querySelector('[data-hg-fresults]');
      if (!box) throw new Error('no results markup');
      var res = { title: box.getAttribute('data-collection-title'), url: box.getAttribute('data-collection-url') || url, cards: Array.prototype.slice.call(box.querySelectorAll('[data-hg-fcard]')) };
      cache[url] = res;
      return res;
    });
  }
  function fetchAll(cols) {
    return Promise.all(cols.map(function (col) { return fetchCategory(col.url); }));
  }
  /* Up to 3 cards for one answer (2026-10-13): the rule's +IDs first (if available), then the categories' best-sellers
     without the -IDs ("only" = nothing but the +IDs). Only if none of them is available: the same matches, sold out. */
  function choose3(rule, groups) {
    var pin = (rule && rule.pin) || [], not = (rule && rule.not) || [], only = !!(rule && rule.only);
    var all = [];
    groups.forEach(function (res) {
      res.cards.forEach(function (c) {
        var id = c.getAttribute('data-pid');
        if (!all.some(function (x) { return x.id === id; })) all.push({ id: id, card: c, cat: { title: res.title, url: res.url } });
      });
    });
    function ok(x) { return only ? pin.indexOf(x.id) > -1 : not.indexOf(x.id) < 0; }
    function avail(x) { return x.card.getAttribute('data-available') === 'true'; }
    var out = [];
    pin.forEach(function (id) { all.forEach(function (x) { if (x.id === id && avail(x) && out.indexOf(x) < 0) out.push(x); }); });
    all.forEach(function (x) { if (avail(x) && ok(x) && out.indexOf(x) < 0) out.push(x); });
    if (!out.length) all.forEach(function (x) { if (ok(x)) out.push(x); });
    return out.slice(0, 3);
  }
  function plan() {
    var p = problemById(state.problem);
    var rules = rulesFor(p, state.location);
    if (!rules.length) return { mode: 'single', collections: [{ url: p.url, title: p.title }], seeAll: p.url };
    if (state.method && state.method !== 'none') {
      var r = rules.filter(function (x) { return x.method === state.method; })[0];
      return { mode: 'single', method: state.method, rule: r, collections: r.collections, seeAll: r.collections[0].url };
    }
    if (rules.length === 1) return { mode: 'single', method: rules[0].method, rule: rules[0], collections: rules[0].collections, seeAll: rules[0].collections[0].url };
    // no preference: one best match per method, so the three choices differ in approach
    var seen = [], picks = [];
    rules.forEach(function (x) { if (seen.indexOf(x.method) < 0 && picks.length < 3) { seen.push(x.method); picks.push(x); } });
    var seeAll = explicitLoc() ? rules[0].collections[0].url : p.url;
    return { mode: 'spread', picks: picks, seeAll: seeAll };
  }
  function answersText() {
    var p = problemById(state.problem);
    var parts = [p.label];
    if (explicitLoc()) parts.push(T.loc[state.location]);
    if (state.method && state.method !== 'none') parts.push(T.method[state.method] || state.method);
    return parts.join(' · ');
  }
  /* The reason ("Ihre Auswahl … aus der HexGuard-Kategorie …") is the same for every card of one category, so it is
     shown once above the cards (contextLine). A card only carries its own facts: the method in "no preference"
     mode and how many versions the product has. */
  function decorate(card, tag) {
    var c = card.cloneNode(true);
    var w = c.querySelector('[data-hg-why]');
    var variants = parseInt(c.getAttribute('data-variants'), 10) || 1;
    if (w) {
      w.textContent = '';
      if (tag) w.appendChild(el('span', { class: 'hg-fcard__tag', text: tag }));
      if (variants > 1) w.appendChild(el('span', { class: 'hg-fcard__variants', text: fmt(T.variants, { '__N__': variants }) }));
    }
    var b2b = c.querySelector('[data-hg-b2b-detail]');
    if (b2b) b2b.hidden = !state.b2b;
    return c;
  }

  function contextLine(answers, cats) {
    // cats: [{ title, url }] actually used for the shown cards (deduplicated); every category stays reachable
    var seen = {}, uniq = cats.filter(function (c) { if (!c || !c.title || seen[c.url]) return false; seen[c.url] = 1; return true; });
    var p = el('p', { class: 'hg-lf__context' }, [el('span', { class: 'hg-lf__context-answers', text: fmt(T.context, { '__A__': answers }) })]);
    if (uniq.length) {
      var tpl = uniq.length > 1 ? T.source_many : T.source_one;
      var parts = tpl.split('__CAT__');
      p.appendChild(document.createTextNode(' '));
      var src = el('span', { class: 'hg-lf__context-source' }, [parts[0]]);
      uniq.forEach(function (c, i) {
        if (i) src.appendChild(document.createTextNode(', '));
        src.appendChild(el('a', { href: c.url, text: c.title }));
      });
      src.appendChild(document.createTextNode(parts[1] || ''));
      p.appendChild(src);
    }
    return p;
  }

  function renderResults() {
    stage.innerHTML = '';
    if (state.problem === 'unsure') return renderUnsure();
    var myId = ++requestId;
    var head = el('div', { class: 'hg-lf__results-head' }, [el(HL, { class: 'hg-lf__q', tabindex: '-1', 'data-hg-focus': '', text: T.results })]);
    var list = el('div', { class: 'hg-lf__results', 'aria-busy': 'true' }, [el('p', { class: 'hg-lf__loading', text: T.loading })]);
    var toggle = el('label', { class: 'hg-lf__b2b' }, [
      el('input', { type: 'checkbox', id: 'hg-lf-b2b', onchange: function (e) {
        state.b2b = e.target.checked;
        list.querySelectorAll('[data-hg-b2b-detail]').forEach(function (d) { d.hidden = !state.b2b; });
        b2bBox.hidden = !state.b2b;
      } }),
      el('span', { text: T.b2b_toggle })
    ]);
    if (state.b2b) toggle.querySelector('input').checked = true;
    var b2bBox = el('div', { class: 'hg-lf__b2b-box' }, [el('p', { text: T.b2b_text }), D.links.b2b ? el('a', { class: 'hg-lf__link', href: D.links.b2b, text: T.b2b_cta + ' →' }) : null]);
    b2bBox.hidden = !state.b2b;
    var pl = plan();
    var actions = el('div', { class: 'hg-lf__actions' }, [
      el('a', { class: 'hg-btn hg-btn--ghost', href: pl.seeAll, text: T.see_all }),
      el('button', { type: 'button', class: 'hg-lf__link', onclick: back, text: T.change }),
      el('button', { type: 'button', class: 'hg-lf__link', onclick: restart, text: T.restart })
    ]);
    var ctxBox = el('div', { class: 'hg-lf__context-box' }); // the shared match reason, right under the heading
    stage.appendChild(el('div', {}, [head, ctxBox, toggle, list, b2bBox, actions]));

    var job;
    if (pl.mode === 'single') {
      // all categories of the answer (e.g. "Köderstationen" + "Sets"), then the curated pick (choose3)
      job = fetchAll(pl.collections).then(function (groups) {
        return choose3(pl.rule, groups).map(function (x) { return { card: x.card, cat: x.cat }; });
      });
    } else {
      job = Promise.all(pl.picks.map(function (r) {
        return fetchAll(r.collections).then(function (groups) {
          var x = choose3(r, groups)[0];
          return x ? { card: x.card, tag: fmt(T.method_tag, { '__M__': T.method[r.method] || r.method }), cat: x.cat } : null;
        });
      })).then(function (arr) { return arr.filter(Boolean); });
    }

    job.then(function (items) {
      if (myId !== requestId) return; // a newer answer replaced this request
      list.innerHTML = '';
      list.setAttribute('aria-busy', 'false');
      var anyAvailable = items.some(function (it) { return it.card.getAttribute('data-available') === 'true'; });
      if (!items.length || !anyAvailable) {
        list.appendChild(el('div', { class: 'hg-lf__empty' }, [
          el('p', { text: T.none_available }),
          el('div', { class: 'hg-lf__actions' }, [
            D.links.contact ? el('a', { class: 'hg-btn', href: D.links.contact, text: T.contact }) : null,
            el('a', { class: 'hg-btn hg-btn--ghost', href: problemById(state.problem).url, text: T.open_category })
          ])
        ]));
        if (items.length) list.appendChild(el('p', { class: 'hg-lf__soldout-note', text: T.soldout_note }));
      }
      if (items.length) {
        var answers = answersText() + (pl.mode === 'spread' ? ' · ' + T.no_pref : '');
        ctxBox.appendChild(contextLine(answers, items.map(function (it) { return it.cat; })));
      }
      var grid = el('div', { class: 'hg-lf__cards' });
      items.forEach(function (it) { grid.appendChild(decorate(it.card, it.tag)); });
      if (items.length) list.appendChild(grid);
      announce(anyAvailable ? fmt(T.results_count, { '__N__': items.filter(function (it) { return it.card.getAttribute('data-available') === 'true'; }).length }) : T.none_available);
    }).catch(function () {
      if (myId !== requestId) return;
      list.innerHTML = '';
      list.setAttribute('aria-busy', 'false');
      list.appendChild(el('div', { class: 'hg-lf__empty', role: 'alert' }, [
        el('p', { text: T.error }),
        el('div', { class: 'hg-lf__actions' }, [
          el('button', { type: 'button', class: 'hg-btn', onclick: function () { go('results'); }, text: T.retry }),
          el('a', { class: 'hg-btn hg-btn--ghost', href: pl.seeAll, text: T.open_category })
        ])
      ]));
      announce(T.error);
    });
  }

  function renderUnsure() {
    stage.appendChild(el('div', { class: 'hg-lf__unsure' }, [
      el(HL, { class: 'hg-lf__q', tabindex: '-1', 'data-hg-focus': '', text: T.unsure_title }),
      el('p', { text: T.unsure_text }),
      el('div', { class: 'hg-lf__actions' }, [
        D.links.contact ? el('a', { class: 'hg-btn', href: D.links.contact, text: T.contact }) : null,
        el('a', { class: 'hg-btn hg-btn--ghost', href: D.links.collections, text: T.open_category })
      ]),
      el('div', { class: 'hg-lf__nav' }, [el('button', { type: 'button', class: 'hg-lf__link', onclick: back, text: '← ' + T.back })])
    ]));
    announce(T.unsure_title);
  }

  /* ---------- open / close / restart ---------- */
  function restart(opts) {
    requestId++;
    state = { problem: null, location: null, method: null, b2b: false, step: 'problem' };
    go('problem', opts);
  }
  if (standalone) {
    // no autofocus/scroll on page load; the page H1 introduces the first question
    restart({ focus: false });
    return;
  }
  function open() {
    root.hidden = false;
    startBtn.setAttribute('aria-expanded', 'true');
    if (launch) launch.classList.add('is-open');
    if (!stage.childNodes.length) restart();
    var t = root.querySelector('[data-hg-lf-title]');
    root.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    if (t) t.focus({ preventScroll: true });
  }
  function close() {
    root.hidden = true;
    startBtn.setAttribute('aria-expanded', 'false');
    if (launch) launch.classList.remove('is-open');
    startBtn.focus();
  }

  startBtn.addEventListener('click', function (e) { e.preventDefault(); open(); });
  root.querySelector('[data-hg-lf-close]').addEventListener('click', close);
  root.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();
